import React, {Component} from 'react';
import {PropTypes} from "prop-types";
import "./Claims.scss";

class ClaimsCell extends Component {

    static propTypes = {
        className: PropTypes.string,
        cellData: PropTypes.object,
        onClaimUpdate: PropTypes.func,
    }
    handleValueChange = (e) => {
        this.props.onClaimUpdate(e);
    }
    handleOnBlur = (e) => {
        e.target.value = e.target.value.trim();
        this.props.onClaimUpdate(e);
    }

    render() {
        return (
            <input className={this.props.className}
                   type='text'
                   name={this.props.cellData.type}
                   value={this.props.cellData.value}
                   id={this.props.cellData.type + this.props.cellData.id}
                   placeholder={this.props.cellData.placeholder}
                   onChange={this.handleValueChange}
                   onBlur={this.handleOnBlur}/>
        );
    }
}

export default ClaimsCell;
